import styled, { css } from 'styled-components';

import { getThemeColor, getThemeTransition } from '@utils/styled';

import Typography from '@common/components/Typography';

const hiddenInputStyles = css`
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
`;

export const FilterRow = styled.label`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 6.4rem;
  outline: none;
  border: none;
  border-bottom: 1px solid ${getThemeColor('bluegrey.90')};
  background-color: ${({ selected }) =>
    selected ? getThemeColor('bluegrey.97') : 'transparent'};
  transition: ${getThemeTransition('background-color')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:hover,
  &:focus-within {
    background-color: ${getThemeColor('bluegrey.97')};
  }
`;

export const Title = styled(Typography).attrs({
  customAs: 'span',
  variant: 'body2',
})`
  flex: 1;
  margin: 0;
  color: ${({ isDisabled }) =>
    isDisabled ? getThemeColor('bluegrey.70') : getThemeColor('bluegrey.15')};
  font-weight: 500;
`;

export const SizeTitle = styled(Title)`
  color: ${({ isDisabled }) =>
    isDisabled ? getThemeColor('bluegrey.70') : getThemeColor('bluegrey.15')};
  text-transform: uppercase;
`;

export const ItemsCount = styled(Typography).attrs({
  customAs: 'span',
  variant: 'body4',
})`
  margin: 0;
  color: ${getThemeColor('bluegrey.60')};
`;

export const MockedRadio = styled.div`
  display: inline-flex;
  width: 2.4rem;
  height: 2.4rem;
  margin-left: 1.5rem;
  border: 1px solid ${getThemeColor('bluegrey.70')};
  ${({ selected }) =>
    selected &&
    css`
      border: 0.7rem solid ${getThemeColor('hue.green')};
    `};
  border-radius: ${({ theme }) => theme.borderRadiuses.pill}rem;
  background: ${getThemeColor('grey.100')};
  transition: ${getThemeTransition('all')};
`;

export const Radio = styled.input.attrs({
  type: 'radio',
})`
  ${hiddenInputStyles};
`;

const getCheckboxBackgroundColor = (disabled, selected) => {
  if (disabled) {
    return getThemeColor('bluegrey.95');
  }

  if (selected) {
    return getThemeColor('hue.green');
  }

  return getThemeColor('grey.100');
};

export const MockedCheckbox = styled.div`
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
  width: 2.4rem;
  height: 2.4rem;
  margin-left: 1.5rem;
  border: 1px solid
    ${({ selected }) =>
      selected ? getThemeColor('hue.green') : getThemeColor('bluegrey.70')};
  border-radius: ${({ theme }) => theme.borderRadiuses['normal.1']}rem;
  background-color: ${({ disabled, selected }) =>
    getCheckboxBackgroundColor(disabled, selected)};
  color: ${({ disabled, selected }) =>
    !disabled && selected ? getThemeColor('grey.100') : 'transparent'};
  transition: ${getThemeTransition('all')};

  svg {
    fill: currentColor;
    width: 14px;
    height: 11px;
  }
`;

export const Checkbox = styled.input.attrs({
  type: 'checkbox',
})`
  ${hiddenInputStyles};
`;
